module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"administration":"Administration"},"fr":{"administration":"Administration"}}')
  delete Component.options._Ctor
}
